module.exports = __webpack_public_path__ + "static/img/title-test-2.8b09181.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/report/title-test-2.png
// module id = MlTP
// module chunks = 1